import React, { useState, useContext } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton } from "@material-ui/core";
import {AddCircleOutline, Delete} from '@material-ui/icons'
import { AddBannerDialog, DeleteBannerDialog } from "./BannerDialogs";
import { StyledDarkBlueButton } from "../../styles/BootstrapStyles";
import { BannerContext } from "../../context/BannerContext";
import { formatDateTimeLocalDisplay } from "../../utils/BannerUtils";
import "./BannerListView.scss";

interface Banner {
  _id: string;
  type: "info" | "warning" | "error";
  startDate: string;
  endDate: string;
  pages: string[];
  message: string;
}

export const BannerListView = () => {
    const [addBannerDialogOpen, setAddBannerDialogOpen] = useState(false);
    const [deleteBannerDialogOpen, setDeleteBannerDialogOpen] = useState(false);
    const [deleteBannerId, setDeleteBannerId] = useState(null);
    const [selectedBanner, setSelectedBanner] = useState(null);
    const { onAddBanner, onDeleteBanner, onUpdateBanner, banners } = useContext(BannerContext);

    const handleEditBanner = (banner: Banner) => {
      setSelectedBanner(banner);
      setAddBannerDialogOpen(true);
    }
    
    const handleSubmitBanner = (banner: Banner) => {
      if(selectedBanner) {
        onUpdateBanner(banner);
      } else {
        onAddBanner(banner);
      }
      setAddBannerDialogOpen(false)
      setSelectedBanner(null);
    }

    const handleCloseBannerDialog = () => {
      setAddBannerDialogOpen(false);
      setSelectedBanner(null);
      setDeleteBannerDialogOpen(false);
      setDeleteBannerId(null);
    }

    const handleDeleteBanner = (bannerId: string) => {
      onDeleteBanner(bannerId);
      setDeleteBannerDialogOpen(false)
    }

    return (
        <div className="banners-container">
            <div className="banners-header">
                <h2 className="banners-title">
                    Banners
                </h2>
                <StyledDarkBlueButton
                    className="banners-add-button"
                    onClick={() => {setAddBannerDialogOpen(true);}}>
                        Add Banner
                        <AddCircleOutline className="banners-add-icon" />
                </StyledDarkBlueButton>
            </div>
            <div className="banners-total">
              Total: <strong>{banners.length}</strong>
            </div>
            <TableContainer className="banners-table-container">
              <Table size="small" className="banners-table">
                <TableHead>
                  <TableRow>
                    <TableCell className="number-column">#</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Start Date</TableCell>
                    <TableCell>End Date</TableCell>
                    <TableCell className="actions-column">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {banners.map((banner, index) => (
                    <TableRow key={banner._id} onClick={() => handleEditBanner(banner)}>
                      <TableCell className="number-column">{index + 1}</TableCell>
                      <TableCell>{banner.type}</TableCell>
                      <TableCell>{formatDateTimeLocalDisplay(banner.startDate)}</TableCell>
                      <TableCell>{formatDateTimeLocalDisplay(banner.endDate)}</TableCell>
                      <TableCell className="action-column">
                        <IconButton
                          className="delete-banner-button"
                          aria-label="delete banner"
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setDeleteBannerId(banner._id);
                            setDeleteBannerDialogOpen(true);
                          }}
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <AddBannerDialog
                open={addBannerDialogOpen}
                onClose={() => handleCloseBannerDialog()}
                onSubmit={(banner) => handleSubmitBanner(banner)}
                mode= {selectedBanner ? "edit" : "add"}
                banner={selectedBanner}
            /> 
            <DeleteBannerDialog
                open={deleteBannerDialogOpen}
                onClose={() => handleCloseBannerDialog()}
                onSubmit={() => handleDeleteBanner(deleteBannerId)}
            />
        </div>
    )
};